import _ from 'lodash'
import store from '@/store'
import { i18n } from '@/i18n'
import { getLanguages } from '@/services/app/getLanguages'
import { getEstadosFacturas } from '@/services/app/getEstadosFacturas'
import { getNotificationsType } from '@/services/app/getNotificationsType'
import { companies } from '@/services/app/getCompanies'
import { unlinkCertificate } from '@/services/certificates/unlinkCertificate'
import { getAnnouncements } from '@/services/app/getAnnouncements'
import { getColumnsVistas } from '@/services/grids/getColumnsVistas'
import { getColors } from '@/services/app/getColors'
import { feedbackMixin } from '@/mixins/appMixin'

const state = () => ({
  version: process.env.VUE_APP_VERSION,
  darkMode: false,
  loading: false,
  showPrimaryMenu: true,
  navFromMenu: false,
  feedback: {
    showing: false,
    data: {}
  },
  errors: [],
  relatedBusinesses: [],
  headerCore: {
    companyId: null,
    businessId: null
  },
  queryHeaders: {
    companyId: null,
    businessId: null
  },
  languages: [],
  AllCifs: [],
  Empresas: [],
  TiposAccionesFacturas: [],
  InvoicesTypes: [],
  gettingCifs: false,
  gettingEmpresas: false,
  gettingNotifsStatus: false,
  gettingNotifsTypes: false,
  gettingAnnouncements: false,
  isAdmin: false,
  unlinkingCert: false,
  AnnouncementsList: [],
  LocalAnnouncementsList: [],
  headerBreadCrumb: null,
  stateBreadCrumb: null,
  actualRoute: null,
  actualRoutePublic: true,
  fromRoute: null,
  isLower1024: false,
  isLower1650: false,
  // Filter nav
  idClienteFilterNav: null,
  idClienteFilterINav: null,
  idClienteFilterRNav: null,
  idClienteFilterVNav: null,
  idClienteFilterIssuing: null,
  idClienteFilterUpload: null,
  idClienteFilterAlerts: null,
  // Searches
  tiposServicio: [],
  tiposPartners: [],
  tiposGruposClientes: [],
  tiposPGE: [],
  // Menu State
  menuState: { 
    1: true,
    2: true,
    3: true,
    6: true,
    7: false,
    10: true,
    11: true,
    12: false,
    13: true, 
  },
  // Otros
  lastVisitedPatchNotes: 'v.1.0.0',
  controlFlagLicense: false,
  autoIdleTime: false,
  // Colores
  colors: null,
  // Cambios formularios sin guardar
  formChanges: false,

  // SIN USO
  tourFirstStepsActive: false,
})

const getters = {
  colors: state => state.colors,
  formChanges: state => state.formChanges,
  idClienteFilterNav: state => state.idClienteFilterNav,
  idClienteFilterINav: state => state.idClienteFilterINav,
  idClienteFilterRNav: state => state.idClienteFilterRNav,
  idClienteFilterVNav: state => state.idClienteFilterVNav,
  idClienteFilterIssuing: state => state.idClienteFilterIssuing,
  idClienteFilterUpload: state => state.idClienteFilterUpload,
  idClienteFilterAlerts: state => state.idClienteFilterAlerts,
  tourFirstStepsActive: state => state.tourFirstStepsActive,
  autoIdleTime: state => state.autoIdleTime,
  controlFlagLicense: state => state.controlFlagLicense,
  lastVisitedPatchNotes: state => state.lastVisitedPatchNotes,
  menuState: state => state.menuState,
  tiposServicio: state => state.tiposServicio,
  tiposPartners: state => state.tiposPartners,
  tiposGruposClientes: state => state.tiposGruposClientes,
  tiposPGE: state => state.tiposPGE,
  version: state => state.version,
  actualRoute: state => state.actualRoute,
  actualRoutePublic: state => state.actualRoutePublic,
  fromRoute: state => state.fromRoute,
  fromRouteName: state => state.fromRoute.name,
  headerBreadCrumb: state => state.headerBreadCrumb,
  stateBreadCrumb: state => state.stateBreadCrumb,
  darkMode: state => state.darkMode,
  navFromMenu: state => state.navFromMenu,
  loading: state => state.loading,
  showPrimaryMenu: state => state.showPrimaryMenu,
  feedback: state => state.feedback.data,
  showingFeedback: state => state.feedback.showing,
  errors: state => state.errors,
  rfheaderCoreCompany: state => state.headerCore.companyId,
  ffheaderCoreBusiness: state => state.headerCore.businessId,
  rfqueryHeaders: state => state.queryHeaders,
  rfheaderCore: state => state.headerCore,
  languagesAvailables: state => {
    if (!_.isEmpty(state.languages.data)) {
      return _.map(state.languages.data, item => {
        return { code: item.code, name: item.name }
      })
    } else {
      return []
    }
  },
  businessesForSelect: (state) => {
    const data = []
    if (state.user) {
      const count = state.relatedBusinesses ? state.relatedBusinesses.length : 0
      for (let i = 0; i < count; i++) {
        const _temp = {}
        _temp.value = state.relatedBusinesses[i].id
        _temp.label = state.relatedBusinesses[i].name
        data.push(_temp)
      }
    }
    return data
  },
  gettingCifs: state => state.gettingCifs,
  allCifs: state => state.AllCifs,
  empresas: state => state.Empresas,
  isAdmin: state => state.isAdmin,
  TiposAccionesFacturas: state => {
    const tiposEstado = store.getters['config/TIPOS_ESTADO']
    const tiposCabecera = store.getters['config/TIPOS_CABECERA']
    const tiposEstadoRecibidas = store.getters['config/TIPOS_ESTADO_RECEPCION']
    const tiposEstadoVerifactu = store.getters['config/TIPOS_ESTADO_VERIFACTU']
    const tiposAccion = store.getters['config/TIPOS_ACCION']
    const tiposOperacion = store.getters['config/TIPOS_OPERACION']
    state.TiposAccionesFacturas.FacturasEmitidas.forEach(grupo => {
      const cabecera = tiposCabecera.find(x => grupo.idCabecera === x.id)
      if (cabecera) {
        grupo.menuId = cabecera.menuId || undefined
        grupo.Descripcion = cabecera.Nombre
      } else {
        console.warn(i18n.t('feedback.warning.unrecognized_invoice_header_warn', { header: grupo.idCabecera }))
        grupo.Descripcion = String(grupo.idCabecera)
      }
      grupo.Estados.forEach(estado => {
        const status = tiposEstado.find(x => estado.idEstado === x.id)
        if (status) {
          estado.Descripcion = status.Nombre
          estado.InfoAdicional = status.Info
        } else {
          console.warn(i18n.t('feedback.warning.unrecognized_invoice_status_warn', { status: estado.idEstado }))
          estado.Descripcion = String(estado.idEstado)
          estado.InfoAdicional = String(estado.idEstado)
        }
        estado.Acciones.forEach(accion => {
          const action = tiposAccion.find(x => x.id === accion.IdAccion)
          if (action) {
            accion.Descripcion = action.Nombre
          } else {
            console.warn(i18n.t('feedback.warning.unrecognized_invoice_action_warn', { action: accion.IdAccion }))
            accion.Descripcion = accion.IdAccion
          }
        })
      })
    })
    state.TiposAccionesFacturas.FacturasRecibidas.forEach(grupo => {
      const cabecera = tiposCabecera.find(x => grupo.idCabecera === x.id)
      if (cabecera) {
        grupo.menuId = cabecera.menuId || undefined
        grupo.Descripcion = cabecera.Nombre
      } else {
        console.warn(i18n.t('feedback.warning.unrecognized_invoice_header_warn', { header: grupo.idCabecera }))
        grupo.Descripcion = String(grupo.idCabecera)
      }
      grupo.Estados.forEach(estado => {
        const status = tiposEstadoRecibidas.find(x => estado.idEstado === x.id)
        if (status) {
          estado.Descripcion = status.Nombre
          estado.InfoAdicional = status.Info
        } else {
          console.warn(i18n.t('feedback.warning.unrecognized_invoice_status_warn', { status: estado.idEstado }))
          estado.Descripcion = String(estado.idEstado)
          estado.InfoAdicional = String(estado.idEstado)
        }
        estado.Acciones.forEach(accion => {
          const action = tiposAccion.find(x => x.id === accion.IdAccion)
          if (action) {
            accion.Descripcion = action.Nombre
          } else {
            console.warn(i18n.t('feedback.warning.unrecognized_invoice_action_warn', { action: accion.IdAccion }))
            accion.Descripcion = accion.IdAccion
          }
        })
      })
    })
    state.TiposAccionesFacturas.RegistrosVerifactu.forEach(grupo => {
      const cabecera = tiposCabecera.find(x => grupo.idCabecera === x.id)
      if (cabecera) {
        grupo.menuId = cabecera.menuId || undefined
        grupo.Descripcion = cabecera.Nombre
      } else {
        console.warn(i18n.t('feedback.warning.unrecognized_invoice_header_warn', { header: grupo.idCabecera }))
        grupo.Descripcion = String(grupo.idCabecera)
      }
      grupo.Estados.forEach(estado => {
        const status = tiposEstadoVerifactu.find(x => estado.idEstado === x.id)
        if (status) {
          estado.Descripcion = status.Nombre
          estado.InfoAdicional = status.Info
        } else {
          console.warn(i18n.t('feedback.warning.unrecognized_invoice_status_warn', { status: estado.idEstado }))
          estado.Descripcion = String(estado.idEstado)
          estado.InfoAdicional = String(estado.idEstado)
        }
        estado.Acciones.forEach(accion => {
          const action = tiposOperacion.find(x => x.id === accion.idTipoOperacion)
          if (action) {
            accion.Descripcion = action.Nombre
          } else {
            console.warn(i18n.t('feedback.warning.unrecognized_invoice_action_warn', { action: accion.idTipoOperacion }))
            accion.Descripcion = accion.idTipoOperacion
          }
        })
      })
    })
    return state.TiposAccionesFacturas
  },
  tiposAccionesFacturasGroups: (state, getters) => getters.TiposAccionesFacturas,
  invoicesTypes: state => state.InvoicesTypes,
  tiposAccionesFacturasEmitidas: (state, getters) => {
    const statusActions = []
    getters.TiposAccionesFacturas.FacturasEmitidas.forEach(grupo => {
      grupo.Estados.forEach(estado => {
        statusActions.push(estado)
      })
    })
    return statusActions
  },
  tiposAccionesFacturasRecibidas: (state, getters) => {
    const statusActions = []
    getters.TiposAccionesFacturas.FacturasRecibidas.forEach(grupo => {
      grupo.Estados.forEach(estado => {
        statusActions.push(estado)
      })
    })
    return statusActions
  },
  tiposOperacionesVerifactus: (state, getters) => {
    const statusActions = []
    getters.TiposAccionesFacturas.RegistrosVerifactu.forEach(grupo => {
      grupo.Estados.forEach(estado => {
        statusActions.push(estado)
      })
    })
    return statusActions
  },

  actionsForSelect: (state, getters) => (id, tipoFactura) => {
    if (id === undefined || id === null || id === 99999 || id === '99999') {
      if (tipoFactura === 'Emitida') {
        return getters.tiposAccionesFacturasEmitidas
      } else if (tipoFactura === 'Recibida') {
        return getters.tiposAccionesFacturasRecibidas
      } else {
        return getters.tiposOperacionesVerifactus
      }
    } else {
      if (tipoFactura === 'Emitida') {
        return getters.tiposAccionesFacturasEmitidas.find(status => status.idEstado === id)
      } else if (tipoFactura === 'Recibida') {
        return getters.tiposAccionesFacturasRecibidas.find(status => status.idEstado === id)
      } else {
        return getters.tiposOperacionesVerifactus.find(status => status.idEstado === id)
      }
    }
  },
  getAnnouncementsList: (state, getters) => [...state.AnnouncementsList, ...getters.getLocalAnnouncementsList],
  getLocalAnnouncementsList: (state) => state.LocalAnnouncementsList,
  getIsLower1024: (state) => {
    return state.isLower1024
  },
  getIsLower1650: (state) => {
    return state.isLower1650
  },
}

const mutations = {
  setColors (state, value) {
    state.colors = value
  },
  resetColors (state) {
    state.colors = null
  },
  setFormChanges (state, value) {
    state.formChanges = value
  },
  setidClienteFilterAlerts (state, value) {
    state.idClienteFilterAlerts = value
  },
  setidClienteFilterUpload (state, value) {
    state.idClienteFilterUpload = value
  },
  setidClienteFilterIssuing (state, value) {
    state.idClienteFilterIssuing = value
  },
  setidClienteFilterNav (state, value) {
    state.idClienteFilterNav = value
  },
  setidClienteFilterINav (state, value) {
    state.idClienteFilterINav = value
  },
  setidClienteFilterRNav (state, value) {
    state.idClienteFilterRNav = value
  },
  setidClienteFilterVNav (state, value) {
    state.idClienteFilterVNav = value
  },
  settourFirstStepsActive (state, value) {
    state.tourFirstStepsActive = value
  },
  setautoIdleTime (state, value) {
    state.autoIdleTime = value
  },
  setcontrolFlagLicense (state, value) {
    state.controlFlagLicense = value
  },
  setlastVisitedPatchNotes (state, value) {
    state.lastVisitedPatchNotes = value
  },
  setVersion (state, value) {
    state.version = value
  },
  setMenuState (state, { menuId, active }) {
    state.menuState[menuId] = active
  },
  settiposServicio (state, tiposServicio) {
    state.tiposServicio = tiposServicio
  },
  settiposPartners (state, tiposPartners) {
    state.tiposPartners = tiposPartners
  },
  settiposGruposClientes (state, tiposGruposClientes) {
    state.tiposGruposClientes = tiposGruposClientes
  },
  settiposPGE (state, tiposPGE) {
    state.tiposPGE = tiposPGE
  },
  // settiposNotif (state, tiposNotif) {
  //   state.tiposNotif = tiposNotif
  // },
  setIsLower1024 (state, isLower1024) {
    state.isLower1024 = isLower1024
  },
  setIsLower1650 (state, isLower1650) {
    state.isLower1650 = isLower1650
  },
  setfromRoute (state, value) {
    state.fromRoute = value
  },
  setActualRoute (state, value) {
    state.actualRoute = value
  },
  setActualRoutePublic (state, value) {
    state.actualRoutePublic = value
  },
  setheaderBreadCrumb (state, value) {
    state.headerBreadCrumb = value
  },
  setstateBreadCrumb (state, value) {
    state.stateBreadCrumb = value
  },
  setDarkMode (state, value) {
    state.darkMode = value

    if (value === false) {
      document.body.classList.remove('dark')
    } else {
      document.body.classList.add('dark')
    }
  },
  setRelatedBusiness (state, data) {
    state.relatedBusinesses = data.data ? data.data : data
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setNavigationFromMenu (state, value) {
    state.navFromMenu = value
  },
  setShowPrimaryMenu (state, showPrimaryMenu) {
    state.showPrimaryMenu = showPrimaryMenu
  },
  setFeedback (state, feedback) {
    state.feedback.data = feedback
  },
  setShowingFeedback (state, showing) {
    state.feedback.showing = showing
  },
  setErrors (state, errors) {
    state.errors = errors
  },
  setError (state, error) {
    state.errors = [...state.errors, error]
  },
  clearErrors (state) {
    state.errors = []
  },
  setHeaderCoreCompany (state, companyId) {
    state.headerCore.companyId = companyId
  },
  setHeaderCoreBusiness (state, businessId) {
    state.headerCore.businessId = businessId
  },
  setHeadersQuery (state) {
    state.queryHeaders.businessId = state.headerCore.businessId
    state.queryHeaders.companyId = state.headerCore.companyId
  },
  resetHaderCoreFilters (state) {
    state.headerCore.businessId = null
    state.headerCore.companyId = null
    state.queryHeaders.businessId = state.headerCore.businessId
    state.queryHeaders.companyId = state.headerCore.companyId
  },
  setLanguages (state, data) {
    state.languages = data
  },
  setCifs (state, cifs) {
    state.AllCifs = cifs
  },
  auth_rol (state, isAdmin) {
    state.isAdmin = isAdmin
  },
  auth_request (state) {
    state.status = 'loading'
  },
  get_empresas_request (state) {
    state.gettingEmpresas = true
  },
  get_empresas_success (state, empresas) {
    state.Empresas = empresas
    state.gettingEmpresas = false
  },
  get_empresas_error (state) {
    state.gettingEmpresas = false
  },
  get_cifs_request (state) {
    state.gettingCifs = true
  },
  get_cifs_success (state, cifs) {
    state.AllCifs = cifs
    state.gettingCifs = false
  },
  get_cifs_error (state) {
    state.gettingCifs = false
  },
  unlink_cert_request (state) {
    state.unlinkingCert = true
  },
  unlink_cert_success (state, idCIFEmpresa) {
    state.unlinkingCert = false
    state.AllCifs = state.AllCifs.map(x => {
      if (x.IdCIFEmpresa === idCIFEmpresa) {
        x.Certificado = null
      }
      return x
    })
  },
  unlink_cert_error (state) {
    state.unlinkingCert = false
  },
  get_notifs_request (state) {
    state.gettingNotifsStatus = true
  },
  get_notifs_success (state, tiposAccionesFacturas) {
    state.TiposAccionesFacturas = tiposAccionesFacturas
    state.gettingNotifsStatus = false
  },
  get_notifs_error (state) {
    state.gettingNotifsStatus = false
  },
  get_types_request (state) {
    state.gettingNotifsTypes = true
  },
  get_types_success (state, types) {
    state.InvoicesTypes = types
    state.gettingNotifsTypes = false
  },
  get_types_error (state) {
    state.gettingNotifsTypes = false
  },
  get_announcements_request (state) {
    state.gettingAnnouncements = true
  },
  get_announcements_success (state, announcements) {
    state.AnnouncementsList = announcements
    state.gettingAnnouncements = false
  },
  get_announcements_error (state) {
    state.gettingAnnouncements = false
  },
  addAnnouncements (state, announcements) {
    state.LocalAnnouncementsList.push(...announcements)
  },
  addAnnouncement (state, announcement) {
    state.LocalAnnouncementsList.push(announcement)
  },
  removeAnnouncement (state, link) {
    const index = state.LocalAnnouncementsList.findIndex(x => x.Enlace === link)
    if (index > -1) state.LocalAnnouncementsList.splice(index, 1)
  },
}

const actions = {
  async getColors ({ commit }) {
    const data = await getColors()
    if (data.blnError === true) {
      feedbackMixin(`${data.msgError} [${data.codError}]`)
    } else {
      commit('setColors', data.Colores)
    }
  },
  async updateFrontColors ({ getters, dispatch }) {
    if (getters.colors && getters.colors.length > 0) {
      getters.colors.forEach(color => {
        document.querySelector(':root').style.setProperty(color.Clave, color.Color)
      })
    } else {
      await dispatch('resetColors')
    }
  }, 
  async resetColors ({ commit }) {
    document.querySelector(':root').style.setProperty('--primary-900', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-900'))
    document.querySelector(':root').style.setProperty('--primary-800', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-800'))
    document.querySelector(':root').style.setProperty('--primary-DEFAULT', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-DEFAULT'))
    document.querySelector(':root').style.setProperty('--primary-600', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-600'))
    document.querySelector(':root').style.setProperty('--primary-500', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-500'))
    document.querySelector(':root').style.setProperty('--primary-400', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-400'))
    document.querySelector(':root').style.setProperty('--primary-300', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-300'))
    document.querySelector(':root').style.setProperty('--primary-200', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-200'))
    document.querySelector(':root').style.setProperty('--primary-100', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-100'))
    document.querySelector(':root').style.setProperty('--primary-50', getComputedStyle(document.documentElement).getPropertyValue('--staticprimary-50'))
    document.querySelector(':root').style.setProperty('--secondary-900', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-900'))
    document.querySelector(':root').style.setProperty('--secondary-800', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-800'))
    document.querySelector(':root').style.setProperty('--secondary-DEFAULT', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-DEFAULT'))
    document.querySelector(':root').style.setProperty('--secondary-600', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-600'))
    document.querySelector(':root').style.setProperty('--secondary-500', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-500'))
    document.querySelector(':root').style.setProperty('--secondary-400', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-400'))
    document.querySelector(':root').style.setProperty('--secondary-300', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-300'))
    document.querySelector(':root').style.setProperty('--secondary-200', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-200'))
    document.querySelector(':root').style.setProperty('--secondary-100', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-100'))
    document.querySelector(':root').style.setProperty('--secondary-50', getComputedStyle(document.documentElement).getPropertyValue('--staticsecondary-50'))
    document.querySelector(':root').style.setProperty('--darkblue-900', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-900'))
    document.querySelector(':root').style.setProperty('--darkblue-800', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-800'))
    document.querySelector(':root').style.setProperty('--darkblue-DEFAULT', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-DEFAULT'))
    document.querySelector(':root').style.setProperty('--darkblue-600', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-600'))
    document.querySelector(':root').style.setProperty('--darkblue-500', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-500'))
    document.querySelector(':root').style.setProperty('--darkblue-400', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-400'))
    document.querySelector(':root').style.setProperty('--darkblue-300', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-300'))
    document.querySelector(':root').style.setProperty('--darkblue-200', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-200'))
    document.querySelector(':root').style.setProperty('--darkblue-100', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-100'))
    document.querySelector(':root').style.setProperty('--darkblue-50', getComputedStyle(document.documentElement).getPropertyValue('--staticdarkblue-50'))

    commit('resetColors')
  },
  async getColumnsVistas ({ commit }) {
    const data = await getColumnsVistas()
    if (data.blnError === true) {
      feedbackMixin(`${data.msgError} [${data.codError}]`)
    } else {
      data.respuesta.forEach(element => {
        if (element.Columnas) {
          const columnas = element.Columnas.split(';')
          switch (element.IdVista) {
            case 4:
              commit('companies/setKendoColumns', columnas, { root: true })
              break
            case 6:
              commit('certificates/setKendoColumns', columnas, { root: true })
              break
            case 7:
              commit('certcompanies/setKendoColumns', columnas, { root: true })
              break
            case 8:
              commit('clients/setKendoColumns', columnas, { root: true })
              break
            case 9:
              commit('users/setKendoColumns', columnas, { root: true })
              break
            case 10:
              commit('userscompanies/setKendoColumns', columnas, { root: true })
              break
            case 12:
              commit('userstatus/setKendoColumns', columnas, { root: true })
              break
            case 18:
              commit('historicalInvoice/setKendoColumns', columnas, { root: true })
              break
            case 19:
              commit('historicalCompany/setKendoColumns', columnas, { root: true })
              break
            case 20:
              commit('historicalCert/setKendoColumns', columnas, { root: true })
              break
            case 21:
              commit('historicalClient/setKendoColumns', columnas, { root: true })
              break
            case 22:
              commit('historicalUser/setKendoColumns', columnas, { root: true })
              break
            case 23:
              commit('trashUsers/setKendoColumns', columnas, { root: true })
              break
            case 24:
              commit('trashHistoricalUsers/setKendoColumns', columnas, { root: true })
              break
            case 26:
              commit('trashHistoricalInvoices/setKendoColumns', columnas, { root: true })
              break
            case 27:
              commit('trashCompanies/setKendoColumns', columnas, { root: true })
              break
            case 28:
              commit('trashHistoricalCompanies/setKendoColumns', columnas, { root: true })
              break
            case 29:
              commit('trashCertificates/setKendoColumns', columnas, { root: true })
              break
            case 30:
              commit('trashHistoricalCertificates/setKendoColumns', columnas, { root: true })
              break
            case 40:
              commit('invoicesIssued/setKendoColumns', columnas, { root: true })
              break
            case 41:
              commit('invoicesReceived/setKendoColumns', columnas, { root: true })
              break
            case 42:
              commit('trashInvoicesIssued/setKendoColumns', columnas, { root: true })
              break
            case 43:
              commit('trashInvoicesReceived/setKendoColumns', columnas, { root: true })
              break
            case 44:
              commit('companiespge/setKendoColumns', columnas, { root: true })
              break
            case 45:
              commit('groups/setKendoColumns', columnas, { root: true })
              break
            case 46:
              commit('groupusers/setKendoColumns', columnas, { root: true })
              break
            case 47:
              commit('groupcompanies/setKendoColumns', columnas, { root: true })
              break
            case 48:
              commit('groupstatus/setKendoColumns', columnas, { root: true })
              break
            case 49:
              commit('historicalGroup/setKendoColumns', columnas, { root: true })
              break
            case 50:
              commit('historicalGroup/setKendoColumns', columnas, { root: true })
              break
            case 51:
              commit('historicalGroup/setKendoColumns', columnas, { root: true })
              break
            case 52:
              commit('historicalGroup/setKendoColumns', columnas, { root: true })
              break
            case 53:
              commit('historicalGroup/setKendoColumns', columnas, { root: true })
              break
            case 54:
              commit('historicalGroup/setKendoColumns', columnas, { root: true })
              break
            case 55:
              commit('distributors/setKendoColumns', columnas, { root: true })
              break
            case 56:
              commit('historicalDistributor/setKendoColumns', columnas, { root: true })
              break
            case 57:
              commit('sociedades/setKendoColumns', columnas, { root: true })
              break
            case 58:
              commit('historicalContact/setKendoColumns', columnas, { root: true })
              break
            case 59:
              commit('trashSociedades/setKendoColumns', columnas, { root: true })
              break
            case 60:
              commit('trashHistoricalContacts/setKendoColumns', columnas, { root: true })
              break
            case 61:
              commit('administrativecenters/setKendoColumns', columnas, { root: true })
              break
            case 62:
              commit('impuestos/setKendoColumns', columnas, { root: true })
              break
            case 63:
              commit('historicalImpuestos/setKendoColumns', columnas, { root: true })
              break
            case 64:
              commit('trashImpuestos/setKendoColumns', columnas, { root: true })
              break
            case 65:
              commit('trashHistoricalImpuestos/setKendoColumns', columnas, { root: true })
              break
            case 66:
              commit('products/setKendoColumns', columnas, { root: true })
              break
            case 67:
              commit('historicalProducts/setKendoColumns', columnas, { root: true })
              break
            case 68:
              commit('productsImpuestos/setKendoColumns', columnas, { root: true })
              break
            case 69:
              commit('trashProducts/setKendoColumns', columnas, { root: true })
              break
            case 70:
              commit('trashHistoricalProducts/setKendoColumns', columnas, { root: true })
              break
            case 71:
              commit('sedes/setKendoColumns', columnas, { root: true })
              break
            case 72:
              commit('administrativecentersfb2b/setKendoColumns', columnas, { root: true })
              break
            case 73:
              commit('groupingcompanies/setKendoColumns', columnas, { root: true })
              break
            case 74:
              commit('groupingbuyers/setKendoColumns', columnas, { root: true })
              break
            case 75:
              commit('groupingsellers/setKendoColumns', columnas, { root: true })
              break
            case 76:
              commit('rules/setKendoColumns', columnas, { root: true })
              break
            case 77:
              commit('rulegroups/setKendoColumns', columnas, { root: true })
              break
            case 78:
              commit('historicalRule/setKendoColumns', columnas, { root: true })
              break
            case 79:
              commit('grouprules/setKendoColumns', columnas, { root: true })
              break
            case 80:
              commit('companyprovideruser/setKendoColumns', columnas, { root: true })
              break
            default:
              break
          }
        }
      })
    }
  },
  updateidClienteFilterAlerts ({ commit }, payload) {
    commit('setidClienteFilterAlerts', payload)
  },
  updateidClienteFilterUpload ({ commit }, payload) {
    commit('setidClienteFilterUpload', payload)
  },
  updateidClienteFilterIssuing ({ commit }, payload) {
    commit('setidClienteFilterIssuing', payload)
  },
  updateidClienteFilterNav ({ commit }, payload) {
    commit('setidClienteFilterNav', payload)
  },
  updateidClienteFilterINav ({ commit }, payload) {
    commit('setidClienteFilterINav', payload)
  },
  updateidClienteFilterRNav ({ commit }, payload) {
    commit('setidClienteFilterRNav', payload)
  },
  updateidClienteFilterVNav ({ commit }, payload) {
    commit('setidClienteFilterVNav', payload)
  },
  updateDashboardFilterNav ({ commit, rootGetters }) {
    let payload = {
      idCliente: rootGetters['dashboard/getSelectedClient'],
      Nombre: rootGetters['dashboard/getSelectedClientName'],
    }
    if (payload.idCliente === 0 || payload.idCliente === -1) {
      payload = null
    }
    commit('setidClienteFilterAlerts', payload)
    commit('setidClienteFilterUpload', payload)
    commit('setidClienteFilterIssuing', payload)
    commit('setidClienteFilterNav', payload)
    commit('setidClienteFilterINav', payload)
    commit('setidClienteFilterRNav', payload)
    commit('setidClienteFilterVNav', payload)
  },
  updatetourFirstStepsActive ({ commit }, payload) {
    commit('settourFirstStepsActive', payload)
  },
  updateautoIdleTime ({ commit }, payload) {
    commit('setautoIdleTime', payload)
  },
  updatecontrolFlagLicense ({ commit }, payload) {
    commit('setcontrolFlagLicense', payload)
  },
  updatelastVisitedPatchNotes ({ commit, state }) {
    commit('setlastVisitedPatchNotes', state.version)
  },
  updateVersion ({ commit }) {
    commit('setVersion', process.env.VUE_APP_VERSION)
  },
  setMenuState ({ commit }, payload) {
    commit('setMenuState', payload)
  },
  settiposServicio ({ commit }, payload) {
    commit('settiposServicio', payload)
  },
  settiposPartners ({ commit }, payload) {
    commit('settiposPartners', payload)
  },
  settiposGruposClientes ({ commit }, payload) {
    commit('settiposGruposClientes', payload)
  },
  settiposPGE ({ commit }, payload) {
    commit('settiposPGE', payload)
  },
  // settiposNotif ({ commit }, payload) {
  //   commit('settiposNotif', payload)
  // },
  setIsLower1024 ({ commit }, payload) {
    commit('setIsLower1024', payload)
  },
  setIsLower1650 ({ commit }, payload) {
    commit('setIsLower1650', payload)
  },
  setfromRoute ({ commit }, value) {
    commit('setfromRoute', value)
  },
  setActualRoute ({ commit }, value) {
    commit('setActualRoute', value)
  },
  setActualRoutePublic ({ commit }, value) {
    commit('setActualRoutePublic', value)
  },
  setheaderBreadCrumb ({ commit }, value) {
    commit('setheaderBreadCrumb', value)
  },
  setstateBreadCrumb ({ commit }, value) {
    commit('setstateBreadCrumb', value)
  },
  showFeedback ({ commit }, options) {
    commit('setFeedback', options)
    commit('setShowingFeedback', true)

    const duration = options?.duration || process.env.VUE_APP_DEFAULT_FEEDBACK_DURATION || 3000
    setTimeout(() => {
      commit('setFeedback', {})
      commit('setShowingFeedback', false)
    }, duration)
  },
  hiddenFeedback ({ commit }) {
    commit('setFeedback', {})
    commit('setShowingFeedback', false)
  },
  async getLanguages ({ commit }) {
    const res = await getLanguages()
    commit('setLanguages', res)
  },
  getEmpresas ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('get_empresas_request')
      companies()
        .then(response => {
          if (response.data.blnError) {
            commit('get_empresas_error')
            return Promise.reject(response)
          }
          commit('get_empresas_success', response.data.Empresas)
          resolve(response)
        })
        .catch(err => {
          commit('get_empresas_error')
          reject(err)
        })
    })
  },
  setCifs ({ commit }, cifs) {
    commit('setCifs', cifs)
  },
  unlinkCert ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('unlink_cert_request')
      unlinkCertificate(payload)
        .then(response => {
          if (response.blnError) {
            commit('unlink_cert_error')
            return Promise.reject(response)
          }
          commit('unlink_cert_success', payload.idCIFEmpresa)
          resolve(response)
        })
        .catch(err => {
          commit('unlink_cert_error')
          reject(err)
        })
    })
  },
  getEstadosFacturas ({ commit, rootGetters }, estado) {
    if (rootGetters['auth/role'] === 7) {
      return new Promise((resolve, reject) => {
        const response = []
        commit('get_notifs_success', response)
        resolve(response)
      })
    }
    return new Promise((resolve, reject) => {
      commit('get_notifs_request')
      let params = null
      const iclienteAllViews = rootGetters['app/idClienteFilterINav']
      const rclienteAllViews = rootGetters['app/idClienteFilterRNav']
      const vclienteAllViews = rootGetters['app/idClienteFilterVNav']
      params = {
        idICliente: iclienteAllViews?.idCliente,
        idRCliente: rclienteAllViews?.idCliente,
        idVCliente: vclienteAllViews?.idCliente
      }
      getEstadosFacturas(params).then(response => {
        if (response.blnError) {
          commit('get_notifs_error')
          return Promise.reject(response)
        }
        commit('get_notifs_success', response)
        resolve(response)
      })
        .catch(err => {
          commit('get_notifs_error')
          reject(err)
        })
    })
  },
  getInvoicesTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('get_types_request')
      getNotificationsType().then(response => {
        if (response.blnError) {
          commit('get_types_error')
          return Promise.reject(response)
        }
        commit('get_types_success', response.respuesta)
        resolve(response)
      })
        .catch(err => {
          commit('get_types_error')
          reject(err)
        })
    })
  },
  getAnnouncementsList ({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      commit('get_announcements_request')
      let params = null
      const clienteAllViews = rootGetters['app/idClienteFilterAlerts']
      if (clienteAllViews) {
        params = {
          idCliente: clienteAllViews.idCliente
        }
      }
      getAnnouncements(params).then(response => {
        if (response.blnError) {
          commit('get_announcements_error')
          return Promise.reject(response)
        }
        commit('get_announcements_success', response.ListadoAvisos)
        resolve(response)
      })
        .catch(err => {
          commit('get_announcements_error')
          reject(err)
        })
    })
  },
  addAnnouncements ({ commit }, announcements) {
    commit('addAnnouncements', announcements)
  },
  addAnnouncement ({ commit }, announcement) {
    commit('addAnnouncement', announcement)
  },
  removeAnnouncement ({ commit }, link) {
    commit('removeAnnouncement', link)
  },
  async updateAnnouncement ({ commit, dispatch }, { link, Mensaje = null, params = null, NumeroAvisos = null }) {
    var announcement = await dispatch('getAnnouncement', { link, local: true })
    if (announcement) {
      announcement.Mensaje = Mensaje || announcement.Mensaje
      announcement.params = params || announcement.params
      announcement.NumeroAvisos = NumeroAvisos || announcement.NumeroAvisos
    } else {
      announcement = { Enlace: link, Mensaje, params, NumeroAvisos }
    }
    commit('removeAnnouncement', announcement.Enlace)
    commit('addAnnouncement', announcement)
  },
  replaceAnnouncement ({ commit }, announcement) {
    commit('removeAnnouncement', announcement.Enlace)
    commit('addAnnouncement', announcement)
  },
  getAnnouncement: ({ getters }, { link, local = false }) => (local ? getters.getLocalAnnouncementsList : getters.getAnnouncementsList).find(x => x.Enlace === link),
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
